export default (
  state = {
    show: false,
  },
  action,
) => {
  switch (action.type) {
    case "SHOW_NAVBAR":
      return { ...state, show: action.payload };
    default:
      return state;
  }
};
